import { apiGetClient, apiPostClient, apiPutClient, apiPostImageClient } from "../../api/apiDmsService";
import { toast } from 'react-toastify';
import i18n from "i18next";
const t = i18n.t.bind(i18n);

export const getAllDocTypes = async () => {
    try {
        const response = await apiGetClient.get("documents/types");
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};

export const createDocTypes = async (data) => {
   apiPostClient.headers = {
            'Content-Type': 'multipart/form-data'
        }
    try {
        const response = await apiPostClient.post("documents/type", data);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};

export const updateDocTypes = async (data) => {
    try {
        const response = await apiPutClient.put(`documents/types/${data.id}?typeId=${data.id}`, data);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};

export const getAllSubTypes = async (data) => {
    try {
        const response = await apiGetClient.get(`documents/subtypes/${data}`);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        console.error("Error", error);
        return null;
    }
};


export const createSubTypes = async (data, language) => {
    try {
        const response = await apiPostClient.post("documents/subtype", data);
        
        let subDocName = data?.name; // default to English
        if (language === "jp" && data?.name_JP) {
            subDocName = data.name_JP;
        } else if (language === "ch" && data?.name_CH) {
            subDocName = data.name_CH;
        }

        toast.success(
            t("subDocumentCreatedSuccess", { name: subDocName }),
            { position: "top-center", theme: "dark" }
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};

export const updateSubDocTypes = async (data) => {
    try {
        const response = await apiPutClient.put(`documents/subtypes/${data.id}`,data);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};

export const getAllFiles = async (data) => {
    try {
        const response = await apiGetClient.get(`documents/${data.typeId}/${data.subTypeId}`);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};

export const uploadFiles = async (data) => {
    try {
        const response = await apiPostImageClient.post("documents/upload", data);
    toast.success(t("documentUploadedSuccess"),{position: "top-center",theme: "dark"});
        return response.data;
    } catch (error) {
        return error.response.data;
    }
};

export const getAccessibilityLevels = async (data) => {
    try {
        const response = await apiGetClient.get("documents/access-levels");
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};

export const publishWorkFlow = async (documentId, workFlowApproverId, boolean, row) => {
    try {
        const response = await apiPutClient.put(`documents/${documentId}/${workFlowApproverId}/publish?useWorkflow=${boolean}`);
        boolean
            ? toast.success(t("documentSentForApprovalSuccess", { name: row?.name }),{position: "top-center",theme: "dark"})
            : toast.success(t("documentPublishedSuccess", { name: row?.name }),{position: "top-center",theme: "dark"});
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};

export const reviseDocument = async (data, document) => {
    try {
        const response = await apiPostImageClient.put(`documents/${document?.documentMetaDataId}/revise`, data);
    toast.success(t("documentRevisedSuccess", { name: document?.name }),{position: "top-center",theme: "dark"})
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach(field => {
                errorData?.errors[field].forEach(message => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response.data?.error, { position: "top-center" });
        }
        return null;
    }
};

export const deActivateDocument = async (data, comments) => {
    try {
        const response = await apiPutClient.put(`documents/${data.documentMetaDataId || data.documentId }/deactivate?comments=${comments || ''}`);
        comments
            ? toast.success(t("documentRejectedSuccess", { title: data?.title }),{position: "top-center",theme: "dark"})
            : toast.success(t("documentDeactivatedSuccess", { name: data?.name }),{position: "top-center",theme: "dark"});
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};

export const documentHistory = async (data) => {
    try {
          const response = await apiGetClient.get(`documents/${data.documentMasterId}/versions`);
          return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};

export const getAllAdminUsers = async (data) => {
    try {
          const response = await apiGetClient.get(`documents/admin/users`);
          return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};

export const pendingApprovalFiles = async (approverId) => {
    try {
          const response = await apiGetClient.get(`documents/pending-approvals`);
          return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};

export const approveDocument = async (documentId, data) => {
    try {
          const response = await apiGetClient.put(`documents/${documentId}/approve`);
          toast.success(t("documentApprovedSuccess", { title: data?.title }), {position: "top-center",theme: "dark"});
          return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};

export const getSasToken= async(accessLevel) => {
    try {
          const response = await apiGetClient.get(`documents/${accessLevel}/document/sas`);
          return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
}

export const getDMSDistributionList = async () => {
    try {
          const response = await apiGetClient.get(`documents/distribution-lists`);
          return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};
